var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter"},[_c('div',{staticClass:"label-title"},[_vm._v(" "+_vm._s(_vm.$t('view-Search.filter-title.archetype'))+" ")]),_c('div',{},[_c('div',{staticClass:"d-flex flex-wrap justify-content-center"},[_c('archetype-circle',{model:{value:(_vm.archetype),callback:function ($$v) {_vm.archetype=$$v},expression:"archetype"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }